import React, { FormEvent, useContext, useState } from "react";
import luxoraLogo from "../../../../assets/luxora.png";
import "./signup.scss";
import { SERVER_URL, SIGNUP_API_PATH } from "../../../../global_vars";
import DOMPurify from "dompurify";

interface SignupState {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    msg: string;
}

interface SignupResponse {
    code: number;
    msg: string;
}

function Signup() {

    const [state, setState] = useState<SignupState>({
       first_name: "",
       last_name: "",
       email: "",
       password: "",
       msg: "",
   });

   const handleResetStatusMsg = () => {
        setState({
            ...state,
            msg: "",    
        });
   }

    const handleFirstNameChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            first_name: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handleLastNameChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            last_name: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handleEmailChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            email: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handlePasswordChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            password: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handleSignup = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        fetch(SERVER_URL+SIGNUP_API_PATH, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                first_name: state.first_name,
                last_name: state.last_name,
                email: state.email,
                password: state.password,
            }),
        }).then((resp) => {
            return resp.json();
        }).then((data: SignupResponse) => {
            if(data.code==200){
                //navigate
            }
            setState({
                ...state,
                msg: data.msg
            })
        }).catch((error) => {
            setState({
                ...state,
                msg: `Unknown error occured. Contact administrator. Error: ${error}`
            });
        });
    }


    return (
        <div>
            <div className="container h-100">
                <div className="row justify-content-sm-center h-100">
                    <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-7 col-sm-9">
                        <div className="text-center my-5">
                            <img src={luxoraLogo} alt="Luxora Logo" className="logo" />
                        </div>
                        <div className="card shadow-lg">
                            <div className="card-body p-5">
                                <h1 className="fs-4 card-title fw-bold mb-4" style={{ color: '#001f3f' }}>Register</h1>
                                {state.msg && 
                                <div className="row">
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        <div>{state.msg}</div>
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={handleResetStatusMsg}></button>
                                    </div>
                                </div>
                                }

                                <form method="POST" onSubmit={handleSignup} className="needs-validation" autoComplete="off">
                                    <div className="mb-3">
                                        <label className="mb-2 text-muted" htmlFor="firstName">First Name</label>
                                        <input type="text" className="form-control" id="firstName" name="firstName" placeholder="First Name" onChange={handleFirstNameChange} value={state.first_name} required autoFocus />
                                        <div className="invalid-feedback">
                                            First Name is required
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="mb-2 text-muted" htmlFor="lastName">Last Name</label>
                                        <input type="text" className="form-control" id="lastName" name="lastName" placeholder="Last Name" onChange={handleLastNameChange} value={state.last_name} required />
                                        <div className="invalid-feedback">
                                            Last Name is required
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="mb-2 text-muted" htmlFor="email">E-Mail Address</label>
                                        <input id="email" type="email" className="form-control" name="email" onChange={handleEmailChange} value={state.email} required />
                                        <div className="invalid-feedback">
                                            Email is invalid
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="mb-2 text-muted" htmlFor="password">Password</label>
                                        <input id="password" type="password" className="form-control" name="password" onChange={handlePasswordChange} value={state.password} required />
                                        <div className="invalid-feedback">
                                            Password is required
                                        </div>
                                    </div>

                                    <p className="form-text text-muted mb-3">
                                        By registering you agree with our <a href="/privacy-policy" className="text-dark"> Privacy Policy</a>
                                        {/*terms and condition*/}
                                    </p>

                                    <div className="align-items-center d-flex">
                                        <button type="submit" className="btn btn-deepNavyBlue ms-auto">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="card-footer py-3 border-0">
                                <div className="text-center">
                                    Already have an account? <a href="/login" className="text-dark">Login</a>
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center mt-5 text-muted">
                            Copyright &copy; 2017-2021 &mdash; Your Company
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );

}


export default Signup;